import * as Sentry from '@sentry/react';
import frontVersion from './gen/front-version.json';

const dsn = process.env.REACT_APP_SENTRY_DSN;
const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development';
const devName = process.env.REACT_APP_DEV_NAME; 
const enableInDev = process.env.REACT_APP_ENABLE_SENTRY_IN_DEV === 'true';

// Guards against local dev (no DSN set) and against the ${SENTRY_DSN} placeholder
// being left unsubstituted by docker-entrypoint.sh if SENTRY_DSN isn't configured
// on the container.
if (dsn?.startsWith('https://')) {
  Sentry.init({
    dsn,
    environment,
    release: frontVersion.sha !== 'unknown' ? frontVersion.sha : undefined,

    initialScope: {
      tags: devName ? { "dev.developer": devName } : {},
    },

    beforeSend(event) {
      if (environment === 'development' && !enableInDev) {
        return null; 
      }
      
      return event;
    },
    // RGPD: opt out of every automatic data-collection category so events
    // never carry IP addresses, user identity, cookies, headers or bodies.
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: { request: false, response: false },
      queryParams: false,
      httpBodies: [],
      genAI: { inputs: false, outputs: false },
    },

    integrations: (defaults) => [
      // Drop BrowserSession (crash-free-rate session pings) to send strictly
      // nothing except crash events. Replace Breadcrumbs to stop recording
      // console output and click/DOM trails; navigation and failed-request
      // breadcrumbs are kept.
      ...defaults.filter((integration) => integration.name !== 'BrowserSession' && integration.name !== 'Breadcrumbs'),
      Sentry.breadcrumbsIntegration({ console: false, dom: false }),
    ],

    sendClientReports: false,
  });
}

export { Sentry };

export const sentryRootErrorHandlers = {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
};
